import { Component, signal, OnInit, OnDestroy, inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { AlertComponent } from './shared/components/alert/top-alert/alert';
import { PopupAlertComponent } from './shared/components/alert/popup-alert/popup-alert';
import { filter } from 'rxjs';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, AlertComponent, PopupAlertComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App implements OnInit, OnDestroy {
  protected readonly title = signal('icxbee-fo');
  private router = inject(Router);
  private platformId = inject(PLATFORM_ID);
  private subscription?: Subscription;

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      // Scroll to top on every route navigation
      this.subscription = this.router.events
        .pipe(filter(event => event instanceof NavigationEnd))
        .subscribe(() => {
          // Use requestAnimationFrame + setTimeout to ensure DOM is fully rendered
          requestAnimationFrame(() => {
            setTimeout(() => {
              this.scrollToTop();
            }, 0);
          });
        });
    }
  }

  private scrollToTop(): void {
    try {
      // Scroll window
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
      
      // Scroll document elements for compatibility
      if (document.documentElement) {
        document.documentElement.scrollTop = 0;
      }
      if (document.body) {
        document.body.scrollTop = 0;
      }

      // Scroll nested scrollable containers (for layouts with overflow containers)
      // Main layout container
      const mainLayoutContainer = document.querySelector('.post-login-main');
      if (mainLayoutContainer instanceof HTMLElement) {
        mainLayoutContainer.scrollTop = 0;
      }

      // Guest layout container
      const guestLayoutContainer = document.querySelector('.guest-main');
      if (guestLayoutContainer instanceof HTMLElement) {
        guestLayoutContainer.scrollTop = 0;
      }

      // Scroll auth layout container if it exists
      const authLayoutContainer = document.querySelector('main');
      if (authLayoutContainer instanceof HTMLElement) {
        const style = window.getComputedStyle(authLayoutContainer);
        if (style.overflowY === 'auto' || style.overflowY === 'scroll') {
          authLayoutContainer.scrollTop = 0;
        }
      }
    } catch (error) {
      console.error('Error scrolling to top:', error);
    }
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
